import React from "react";
import { Trans } from "react-i18next";

const NoResultsView = ({ title, message, className }) => {
    return (
        <>
            <div
                className={`no-result-wrapper flex items-center justify-center ${className}`}
            >
                <div className="no-result-item text-center">
                    <div className="no-result-img">
                        <img
                            src={
                                require("../../assets/images/no-result.png")
                                    .default
                            }
                            alt="NoResultImage"
                        />
                    </div>
                    <h3 className="no-result-title">
                        {title || (
                            <Trans i18nKey="couldFindMatches">
                                We couldn&#39;t find any matches...
                            </Trans>
                        )}
                    </h3>
                    <p className="no-result-message">
                        {message || (
                            <Trans i18nKey="doubleCheckMessage">
                                Double check your search for any typos or
                                spelling errors, or try a different search term!
                            </Trans>
                        )}
                    </p>
                </div>
            </div>
        </>
    );
};

export default NoResultsView;
